import moduleSettings from '../Utils/settings.js'

/*
	Since we're dealing with legacy code, we'll use this script to open up the correct accordion from start, instead of extending
	the existing two accordion scripts. We are essentially getting the current URL, taking the hash and opening the accordion with the
	same data-faq-url attribute.

	If not found, we'll open the first accordion in the list.

	On click on each accordion, we are also replacing the hash in the url with the data-faq-url attribute, so that the user can share
	the currently selected accordion.
*/
class Faq {
	constructor(opts, el) {
		this.el = el
		this.options = opts

		// each accordion on the page
		this.accordions = this.el.querySelectorAll(`div[data-faq-url]`)

		this.init()
	}

	init() {
		// get the hash from the URL, minus the actual hash symbol
		const hash = window.location.hash.replace(`#`, ``)
		this.findAccordion(hash)

		// setup click events on existing accordions to replace the hash in the URL
		this.accordions.forEach(accordion => {
			const curr = accordion.querySelector(`.AccordionBlock-toggle`)
			jAwn.on(curr, `toggleAccordion`, e => {
				// only add it to hash if we're opening it, not closing it
				if (!accordion.querySelector(`span.plus-minus-toggle`).classList.contains(`is-collapsed`)) {
					const url = new URL(window.location.href)
					url.hash = accordion.getAttribute(`data-faq-url`)
					window.location = url
				}
            })
        })
	}

	findAccordion(hash) {
		// if the hash is not empty, find the accordion with the same data-faq-url attribute
        if (hash) {
            const accordion = this.el.querySelector(`div[data-faq-url="${hash}"]`)
            if (accordion) {
                this.openAccordion(accordion)
            }
        }
	}

	openAccordion(el) {
		// to open an accordion, we need to remove the `.is-collapsed` class from the following children of the accordion:
		// span.plus-minus-toggle
		// div.AccordionBlock-content
		// .AccordionBlock-image--container
		
		const className = `is-collapsed`
		el.querySelector('.AccordionBlock-toggle')?.classList.remove(className)
		el.querySelector(`span.plus-minus-toggle`)?.classList.remove(className)
		el.querySelector(`div.AccordionBlock-content`)?.classList.remove(className)
		el.querySelector(`.AccordionBlock-image--container`)?.classList.remove(className)
	}
}

export const init = (opts, el) => {
	const settings = moduleSettings.set({
	}, opts)

	new Faq(settings, el)
}